import { BookingQualification } from "@justhome/api-projectupdate";
import { no, yes, YesNo } from "@lib/options";
import { QualificationFormData } from "./types";

export const yesNoToBoolean = (yesNo?: YesNo): boolean | undefined => {
  if (yesNo === yes) return true;
  if (yesNo === no) return false;
  return undefined;
};

const dateToApiDate = (date?: Date): string | undefined => {
  if (!date) return undefined;
  return date.toISOString().split("T")[0];
};

const stringToFloat = (value?: string): number | undefined => {
  if (!value) return undefined;
  return Number(value.replace(",", "."));
};

export const mapFormToBookingQualification = (
  formData: QualificationFormData,
): BookingQualification => {
  return {
    ...formData,
    wantsToSellAProperty: yesNoToBoolean(formData.wantsToSellAProperty),
    propertyViewingStatus: formData.propertyViewingStatus,
    employedSince: dateToApiDate(formData.employedSince),
    realEstateAgentFeePercentage: stringToFloat(
      formData.realEstateAgentFeePercentage,
    ),
  };
};
